import { Link } from "@tanstack/react-router";
import { AREA_PAGES, NEARBY_AREAS, SITE } from "@/lib/site";
import { MapPin, Phone, Mail, Facebook } from "lucide-react";

const AREA_PAGE_SLUGS = new Set(AREA_PAGES.map((a) => a.area));
const AREAS_WITHOUT_PAGE = NEARBY_AREAS.filter((a) => !AREA_PAGE_SLUGS.has(a));

export function SiteFooter() {
  return (
    <footer id="kontakt" className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="font-serif text-2xl">{SITE.name}</div>
            <p className="mt-3 text-sm text-muted-foreground max-w-xs">
              Bilvask-, dekkskift- og oljeskiftspesialister i Drammen.
            </p>
          </div>
          <div className="space-y-3 text-sm">
            <div className="eyebrow">Kontakt</div>
            <a href={SITE.phoneHref} className="flex items-center gap-3 text-foreground/85 hover:text-primary">
              <Phone className="h-4 w-4 text-primary" /> {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-foreground/85 hover:text-primary">
              <Mail className="h-4 w-4 text-primary" /> {SITE.email}
            </a>
            <div className="flex items-start gap-3 text-foreground/85">
              <MapPin className="h-4 w-4 text-primary mt-0.5" /> {SITE.address}
            </div>
            <a
              href={SITE.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-foreground/85 hover:text-primary"
            >
              <Facebook className="h-4 w-4 text-primary" /> Følg oss på Facebook
            </a>
          </div>
          <div className="space-y-3 text-sm">
            <div className="eyebrow">Åpningstider</div>
            <div className="text-foreground/85">Man – Fre: 09:00 – 20:00</div>
            <div className="text-foreground/85">Lør: 09:00 – 19:00</div>
            <div className="text-muted-foreground">Søn: Stengt</div>
            <div className="pt-2 flex flex-col gap-1">
              <Link to="/priser" className="text-foreground/85 hover:text-primary">Priser</Link>
              <Link to="/faq" className="text-foreground/85 hover:text-primary">Ofte stilte spørsmål</Link>
              <a href="/personvern" className="text-foreground/85 hover:text-primary">Personvern</a>
            </div>
          </div>
          <div className="space-y-3 text-sm">
            <div className="eyebrow">Områder vi betjener</div>
            {AREA_PAGES.map((a) => (
              <Link key={a.slug} to={"/" + a.slug as any} className="block text-foreground/85 hover:text-primary">
                Bilvask i {a.area}
              </Link>
            ))}
            {AREAS_WITHOUT_PAGE.length > 0 && (
              <p className="pt-1 text-muted-foreground text-xs leading-relaxed">
                Vi tar også imot kunder fra {AREAS_WITHOUT_PAGE.join(", ")}.
              </p>
            )}
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} {SITE.name}. Alle rettigheter reservert.</div>
          {/* Logoen erstatter ordet "Ascendly". Hvit variant fordi bunnen staar
              paa mork bakgrunn. Understrekingen er tatt bort: en strek under et
              bilde ser ut som en feil. */}
          <div className="flex items-center">
            Laget av{" "}
            <a href="https://ascendly.no/" target="_blank" rel="noopener noreferrer" className="inline-block align-middle transition hover:opacity-80">
              <img
                src="/laget-av-ascendly.png"
                alt="Ascendly"
                loading="lazy"
                decoding="async"
                className="ml-1 inline-block h-8 w-auto align-middle"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}